import { render } from "./ImageAttrs.vue?vue&type=template&id=1cec6069"
import script from "./ImageAttrs.vue?vue&type=script&lang=js"
export * from "./ImageAttrs.vue?vue&type=script&lang=js"

import "./ImageAttrs.vue?vue&type=style&index=0&id=1cec6069&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__